import {AppThunkAction} from "src/~store/models/AppThunkAction";
import { GetAllOperatorsSuccess, GetAuditsAction, SaveAuditTagsAction } from "./interfaces";
import { CLEAR_AUDITS_SUCCESS, GET_AUDIT_ERROR, GET_AUDIT_START, GET_AUDIT_SUCCESS, SAVE_AUDIT_OPERATOR_INFO_SUCCESS, SAVE_AUDIT_TAGS_SUCCESS } from "./types";
import { getAuditsByTagsAsync } from "../../~api/actions";
import { LOAD_AUDITS_COUNT } from "../constants/AuditConstants";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { getAllOperatorsAsync } from "src/app/operator/~api/actions";



export const getAuditsByTags = (skip: number): AppThunkAction<GetAuditsAction> => async (dispatch, getState) => {
    if(!getState().auditState.auditList.isReceivingAudits) {
        if(skip === 0) {
            dispatch({type: CLEAR_AUDITS_SUCCESS}); 
        }
        dispatch({type: GET_AUDIT_START});
        const  tags = getState().auditState.auditList.auditTags;
        const result = await getAuditsByTagsAsync(skip, LOAD_AUDITS_COUNT, tags);
        if (result.isSuccess) {
            const audits = result.value ?? [];

            dispatch({type: GET_AUDIT_SUCCESS, payload: {audits}}); 
        }
        dispatch({type: GET_AUDIT_ERROR});
    }
};

export const getAllOperators = (): AppThunkAction<GetAllOperatorsSuccess> => async (dispatch, getState) => {
    if(getState().auditState.auditList.operators.length === 0) {
        const operatorsResult = await getAllOperatorsAsync(false);

        if(operatorsResult.isSuccess) {
            const operators = operatorsResult.value ?? [];

            dispatch({type: SAVE_AUDIT_OPERATOR_INFO_SUCCESS, payload: {operators}}); 
        }
    }
}

export const saveAuditTags = (tags:ISearchingTag[]): AppThunkAction<SaveAuditTagsAction> => async dispatch => {
    dispatch({type: SAVE_AUDIT_TAGS_SUCCESS, payload: {tags}});
};

